import { render, staticRenderFns } from "./Chargemanagement.vue?vue&type=template&id=50812e66&scoped=true"
import script from "./Chargemanagement.vue?vue&type=script&lang=js"
export * from "./Chargemanagement.vue?vue&type=script&lang=js"
import style0 from "./Chargemanagement.vue?vue&type=style&index=0&id=50812e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50812e66",
  null
  
)

export default component.exports